import { Stack } from '@mui/material';
import PaiTextField from 'features/ui/base-components/pai-text-field';
import { QuestionnaireLanguages, i18nField } from 'features/lead/lead-management/lead-questionnaire-details/lead-questionnaire-details.types';
import React from 'react';
import { BasicActionDialog } from '../../../ui/base-dialogs';

interface Props {
  open: boolean;
  selfAssessment: i18nField;
  externalAssessment: i18nField;

  handleTextFieldChange(type: string, lang: QuestionnaireLanguages): (event: React.ChangeEvent<HTMLInputElement>) => void;

  handleClose(): void;

  handleProceed(): void;
}

const AddQuestionsDialog: React.FC<Props> = ({ open, selfAssessment, externalAssessment, handleTextFieldChange, handleClose, handleProceed }) => {
  return (
    <BasicActionDialog
      dialogTitle={'Frage hinzufügen'}
      maxWidth={'md'}
      cancelButtonText={'Abbrechen'}
      proceedButtonText={'Hinzufügen'}
      open={open}
      handleClose={handleClose}
      handleProceed={handleProceed}
      proceedButtonDisabled={
        selfAssessment.de.trim() === '' ||
        selfAssessment.en.trim() === '' ||
        externalAssessment.de.trim() === '' ||
        externalAssessment.en.trim() === ''
      }
    >
      <Stack gap={2}>
        <Stack direction={'row'} alignContent={'center'} gap={2}>
          <PaiTextField
            value={selfAssessment.de}
            placeholder={'Fragetext zur Selbstbewertung...'}
            label={'Selbstbewertung (deutsch)'}
            onChange={handleTextFieldChange('selfAssessment', QuestionnaireLanguages.DE)}
          />
          <PaiTextField
            value={selfAssessment.en}
            placeholder={'Fragetext zur Selbstbewertung...'}
            label={'Selbstbewertung (englisch)'}
            onChange={handleTextFieldChange('selfAssessment', QuestionnaireLanguages.EN)}
          />
        </Stack>
        <Stack direction={'row'} alignContent={'center'} gap={2}>
          <PaiTextField
            value={externalAssessment.de}
            onChange={handleTextFieldChange('externalAssessment', QuestionnaireLanguages.DE)}
            placeholder={'Fragetext zur Fremdbewertung...'}
            label={'Fremdbewertung (deutsch)'}
          />
          <PaiTextField
            value={externalAssessment.en}
            onChange={handleTextFieldChange('externalAssessment', QuestionnaireLanguages.EN)}
            placeholder={'Fragetext zur Fremdbewertung...'}
            label={'Fremdbewertung (englisch)'}
          />
        </Stack>
      </Stack>
    </BasicActionDialog>
  );
};

export default AddQuestionsDialog;
